import React, { useState } from 'react';
import styled from 'styled-components';
import Top_Menu from '../main/Top_Menu';
import Bottom_Menu from '../main/Bottom_Menu';
import lang from '../language/Eng_eng.json';

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  margin-top: 100px; /* Adjust for Top_Menu fixed height */
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const LeftSection = styled.div`
  flex: 1;
  background-image: url('${process.env.PUBLIC_URL}/image/0O2A6485-2-scaled-e1720657389996.jpg');
  background-size: cover;
  background-position: center;
  min-height: 400px;
`;

const RightSection = styled.div`
  flex: 1.1;
  padding: 5rem 4rem;
  display: flex;
  flex-direction: column;
  background-color: #EBE8DF;
  color: #5C4033;
  @media (max-width: 900px) {
    padding: 3rem 2rem;
  }
`;

const Title = styled.h1`
  font-family: 'EB Garamond', serif;
  font-size: 2.5rem;
  letter-spacing: 0.12rem;
  margin-bottom: 4rem;
  font-weight: 500;
  margin-top: 0;
`;

const ColumnsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 3rem;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const InfoColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const InfoTitle = styled.h3`
  font-family: 'EB Garamond', serif;
  font-size: 1.05rem;
  color: #8C7561;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.06rem;
`;

const InfoText = styled.p`
  font-family: 'EB Garamond', serif;
  font-size: 1.12rem;
  color: #5C4033;
  margin: 0;
  line-height: 1.4;
`;

const InfoTextSub = styled.span`
  font-family: 'EB Garamond', serif;
  font-size: 0.95rem;
  color: #888;
  margin-top: -0.3rem;
`;

const FormColumn = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
`;

const InputGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Input = styled.input`
  width: 100%;
  border: none;
  border-bottom: 1px solid #8C7561;
  background: transparent;
  padding: 0.8rem 0;
  font-family: 'EB Garamond', serif;
  font-size: 1.0rem;
  color: #5C4033;
  outline: none;
  &::placeholder {
    color: #999;
  }
`;

const SendButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  margin-top: 2rem;
  
  &:hover {
    opacity: 0.7;
  }
`;

const ArrowCircle = styled.div`
  width: 35px;
  height: 35px;
  border: 1px solid #5C4033;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SendText = styled.span`
  font-family: 'EB Garamond', serif;
  font-weight: 500;
  font-size: 1.0rem;
  color: #5C4033;
  letter-spacing: 0.08rem;
`;

const Contact: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (!name || !email || !message) {
      alert(lang.contactPage.form.validationMessage);
      return;
    }
    const subject = encodeURIComponent(`Message from ${name}`);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=reservation@alltasydney.com.au&su=${subject}&body=${body}`;
    window.open(gmailLink, '_blank');
  };

  return (
    <Container>
      <Top_Menu />
      <ContentWrapper>
        <LeftSection />
        <RightSection>
          <Title>{lang.contactPage.title}</Title>
          <ColumnsWrapper>
            <InfoColumn>
              <InfoBlock>
                <InfoTitle>{lang.contactPage.tradingHour.title}</InfoTitle>
                <InfoText>{lang.contactPage.tradingHour.days}</InfoText>
                <InfoTextSub>{lang.contactPage.tradingHour.time}</InfoTextSub>
              </InfoBlock>
              <InfoBlock>
                <InfoTitle>{lang.contactPage.serviceHour.title}</InfoTitle>
                <InfoText>{lang.contactPage.serviceHour.days}</InfoText>
                <InfoTextSub>{lang.contactPage.serviceHour.time}</InfoTextSub>
              </InfoBlock>
              <InfoBlock>
                <InfoTitle>{lang.contactPage.location.title}</InfoTitle>
                <InfoText>{lang.contactPage.location.address}</InfoText>
              </InfoBlock>
              <InfoBlock>
                <InfoTitle>{lang.contactPage.phone.title}</InfoTitle>
                <InfoText>{lang.contactPage.phone.number}</InfoText>
              </InfoBlock>
            </InfoColumn>
            <FormColumn>
              <InfoTitle style={{ marginBottom: '1rem' }}>{lang.contactPage.form.title}</InfoTitle>
              <InputGroup>
                <Input type="text" placeholder={lang.contactPage.form.namePlaceholder} value={name} onChange={(e) => setName(e.target.value)} />
              </InputGroup>
              <InputGroup>
                <Input type="email" placeholder={lang.contactPage.form.emailPlaceholder} value={email} onChange={(e) => setEmail(e.target.value)} />
              </InputGroup>
              <InputGroup>
                <Input type="text" placeholder={lang.contactPage.form.messagePlaceholder} value={message} onChange={(e) => setMessage(e.target.value)} />
              </InputGroup>
              <SendButtonContainer onClick={handleSend}>
                <ArrowCircle>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </ArrowCircle>
                <SendText>{lang.contactPage.form.submitButton}</SendText>
              </SendButtonContainer>
            </FormColumn>
          </ColumnsWrapper>
        </RightSection>
      </ContentWrapper>
      <Bottom_Menu />
    </Container>
  );
};

export default Contact;
